module.exports = __webpack_public_path__ + "img/kagami-horn.afa784b7.png";